import { Controller } from "@hotwired/stimulus"

let activeController = null

/**
 * Manages inline editing of content.
 * Toggles between a display view and a form view, ensuring only one editor is active globally.
 */
export default class extends Controller {
  static targets = ["display", "form"]

  /**
   * Switches to edit mode.
   * Locks the global state to prevent multiple simultaneous edits.
   */
  edit(event) {
    event?.preventDefault()

    if (activeController && activeController !== this) {
      return
    }

    activeController = this
    document.body.classList.add("inline-edit-locked")
    this.displayTarget.classList.add("inline-edit-active")
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")

    const input = this.formTarget.querySelector("input[type='text'], textarea")
    if (input) {
      input.focus()
      const len = input.value.length
      input.setSelectionRange(len, len)
    }
  }

  /**
   * Cancels editing and restores display view.
   */
  cancel(event) {
    event?.preventDefault()

    if (activeController === this) {
      activeController = null
      document.body.classList.remove("inline-edit-locked")
    }

    this.displayTarget.classList.remove("inline-edit-active")
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }

  disconnect() {
    if (activeController === this) {
      activeController = null
      document.body.classList.remove("inline-edit-locked")
    }
  }
}
